export const GET_ALL_FAQS= 'GET_ALL_FAQS';
export const LOAD_FAQ_LOADING= 'LOAD_FAQ_LOADING';
export const LOAD_FAQ_ERROR= 'LOAD_FAQ_ERROR';

//SUBMIT CONTACT US FORM
export const ON_SUBMIT_QUERY = 'ON_SUBMIT_QUERY';
export const ON_CONTACTUS_SUCCESSFUL = 'ON_CONTACTUS_SUCCESSFUL';
export const ON_CONTACTUS_ERROR = 'ON_CONTACTUS_ERROR'

